"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "Dzięki profesjonalnemu podejściu udało się uzyskać odszkodowanie znacznie przekraczające ofertę ubezpieczyciela. Jestem bardzo zadowolony z efektów współpracy.",
  name: "SZYMON ŁOSICKI",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/jan_kowalski_testimonial.png"
}, {
  id: 2,
  quote: "Pomoc prawna na najwyższym poziomie. Czułem się bezpiecznie podczas całego procesu dochodzenia zadośćuczynienia po wypadku komunikacyjnym.",
  name: "ANNA ŚPIEWAK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/anna_nowak_testimonial.png"
}, {
  id: 3,
  quote: "Szybka reakcja, jasna komunikacja i konkretne rezultaty. Gorąco polecam każdemu, kto potrzebuje wsparcia w sprawach odszkodowawczych.",
  name: "Piotr Wiśniewski",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/piotr_wisniewski_testimonial.png"
}, {
  id: 4,
  quote: "Po śmierci bliskiej osoby rodzina nie wiedziała, jakie kroki podjąć. Kancelaria poprowadzila nas przez cały proces z empatią i profesjonalizmem.",
  name: "Maria Lewandowska",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/maria_lewandowska_testimonial.png"
}];
export default function OpinionKliencien() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  const progressValue = count > 0 ? (current + 1) / count * 100 : 0;
  return <section id="opinie-klientów" ref={ref} className={`dark bg-background text-foreground py-16 md:py-24 px-4 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-center mb-12 md:mb-16">Opinie klientów</h2>

        <Carousel setApi={setApi} opts={{
        loop: true
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-8 py-8">
                  <blockquote className="font-serif text-2xl md:text-3xl lg:text-4xl leading-relaxed mb-8 max-w-3xl">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>

                  <div className="flex flex-col items-center gap-3">
                    <SafeHydrate><Avatar className="w-16 h-16 ring-2 ring-primary/20">
                      <AvatarImage src={testimonial.image} alt={testimonial.name} />
                      <AvatarFallback className="bg-primary/10 text-foreground text-sm font-semibold">
                        {testimonial.name.split(" ").map(n => n[0]).join("")}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <p className="font-sans text-sm font-semibold tracking-wide uppercase text-muted-foreground">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex items-center justify-center gap-8 mt-8">
            <CarouselPrevious variant="ghost" className="static translate-x-0 translate-y-0 w-12 h-12 rounded-full border border-border hover:bg-primary hover:text-foreground-primary hover:border-primary transition-all duration-[var(--duration-fast)]">
              <ChevronLeft className="w-6 h-6" />
            </CarouselPrevious>

            <CarouselNext variant="ghost" className="static translate-x-0 translate-y-0 w-12 h-12 rounded-full border border-border hover:bg-primary hover:text-foreground-primary hover:border-primary transition-all duration-[var(--duration-fast)]">
              <ChevronRight className="w-6 h-6" />
            </CarouselNext>
          </div>
        </Carousel>

        <div className="mt-8 max-w-md mx-auto">
          <Progress value={progressValue} className="h-1 bg-border" />
        </div>
      </div>
    </section>;
}